/* ANGE quick add: "+" on product cards (see snippets/card-product.liquid). */
(function () {
  if (customElements.get('ange-quick-add')) return;

  /* ANGE: head start for the product page's main photo.
     Each product card carries the exact image sizes the product page uses for its main photo
     (data-ange-pdp-srcset / data-ange-pdp-sizes, set in card-product.liquid). When a card is
     hovered (computer) or rested on (phone), the right one starts downloading in the background
     so the product page opens with the photo usually already there. Nothing visible changes;
     each photo is only fetched once. The "+" quick add button doesn't trigger this.

     SPEED FIX: these background photos are fetched at LOW priority, so they always yield to the
     thumbnails actually on screen (previously 'high', which let them jump ahead of the visible
     grid images as you scrolled over cards). They also only fire on INTENT - after the pointer
     or finger rests on one card briefly - and never while the page is scrolling, so scrolling
     past a column of products no longer kicks off a pile of big downloads. */
  var angePreloaded = {};
  var angePreloadImages = [];
  var angeScrollingUntil = 0;
  function angeMarkScrolling() { angeScrollingUntil = Date.now() + 400; }
  window.addEventListener('scroll', angeMarkScrolling, { passive: true });
  window.addEventListener('touchmove', angeMarkScrolling, { passive: true });
  window.addEventListener('wheel', angeMarkScrolling, { passive: true });

  function angePreloadProductPhoto(card) {
    var srcset = card.getAttribute('data-ange-pdp-srcset');
    if (!srcset || angePreloaded[srcset]) return;
    angePreloaded[srcset] = true;
    try {
      var img = new Image();
      img.decoding = 'async';
      if ('fetchPriority' in img) img.fetchPriority = 'low';
      img.sizes = card.getAttribute('data-ange-pdp-sizes') || '100vw';
      img.srcset = srcset;
      angePreloadImages.push(img);
    } catch (e) {}
  }

  /* Fire only on intent: wait ~160ms of resting on the same card, and skip if a scroll is in
     progress (or started during that wait). A quick pass of the cursor/finger while scrolling
     never triggers a download. */
  var angeHoverTimer = null;
  var angeHoverCard = null;
  function angeSchedulePreload(card) {
    if (angeHoverCard === card) return;
    angeHoverCard = card;
    if (angeHoverTimer) clearTimeout(angeHoverTimer);
    if (Date.now() < angeScrollingUntil) return;
    angeHoverTimer = setTimeout(function () {
      if (Date.now() < angeScrollingUntil) return;
      angePreloadProductPhoto(card);
    }, 160);
  }
  ['touchstart', 'pointerdown', 'mouseover', 'focusin'].forEach(function (eventName) {
    document.addEventListener(
      eventName,
      function (event) {
        var target = event.target;
        if (!target || !target.closest) return;
        if (target.closest('ange-quick-add')) return;
        var card = target.closest('[data-ange-pdp-srcset]');
        if (card) angeSchedulePreload(card);
      },
      { passive: true, capture: true }
    );
  });

  // Short size codes are shown written out in the size card (like the example):
  // XS -> Extra Small, S -> Small, ... Anything else is shown as it is.
  var SIZE_NAMES = {
    XXS: 'Extra Extra Small',
    '2XS': 'Extra Extra Small',
    XS: 'Extra Small',
    S: 'Small',
    M: 'Medium',
    L: 'Large',
    XL: 'Extra Large',
    XXL: 'Extra Extra Large',
    '2XL': 'Extra Extra Large',
    XXXL: 'Triple Extra Large',
    '3XL': 'Triple Extra Large',
  };

  /* Cart drawer clean-up after it is closed.
     When the drawer is opened by the quick add (instead of the product page button
     or the cart icon), the theme doesn't know which element to give focus back to
     on close. Focus then stays on an element inside the now-hidden drawer, and on
     iPhone (Safari) that can leave the dark drawer background on screen and the page
     unscrollable. So: whenever the drawer loses its "active" (open) state, move focus
     out of it and make sure the page can scroll again. */
  function watchCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.__angeCloseWatch) return;
    drawer.__angeCloseWatch = true;
    new MutationObserver(function () {
      if (drawer.classList.contains('active')) return;
      var focused = document.activeElement;
      if (focused && focused !== document.body && drawer.contains(focused)) focused.blur();
      document.body.classList.remove('overflow-hidden');
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  class AngeQuickAdd extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = '1';
      watchCartDrawer();

      this.plus = this.querySelector('.ange-qa__plus');
      this.panel = this.querySelector('.ange-qa__panel');
      this.error = this.querySelector('.ange-qa__error');

      if (this.plus) {
        this.plus.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          if (this.dataset.variantId) {
            this.add(this.dataset.variantId);
          } else {
            this.toggle();
          }
        });
      }

      this.querySelectorAll('.ange-qa__size').forEach((button) => {
        var code = button.textContent.trim();
        var full = SIZE_NAMES[code.toUpperCase()];
        if (full) {
          button.textContent = full;
          button.setAttribute('aria-label', full + (button.disabled ? ' - sold out' : ''));
        }
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          if (button.disabled) return;
          this.add(button.dataset.variantId);
        });
      });

      if (this.panel) {
        this.panel.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
        });
      }

      this.onDocumentClick = (event) => {
        if (!this.contains(event.target)) this.close();
      };
      document.addEventListener('click', this.onDocumentClick);

      this.addEventListener('keyup', (event) => {
        if (event.key === 'Escape') {
          this.close();
          if (this.plus) this.plus.focus();
        }
      });
    }

    disconnectedCallback() {
      if (this.onDocumentClick) document.removeEventListener('click', this.onDocumentClick);
    }

    toggle() {
      if (!this.panel) return;
      if (this.panel.hidden) {
        this.open();
      } else {
        this.close();
      }
    }

    open() {
      if (!this.panel) return;
      document.querySelectorAll('ange-quick-add.is-open').forEach((other) => {
        if (other !== this && typeof other.close === 'function') other.close();
      });
      this.panel.hidden = false;
      this.classList.add('is-open');
      if (this.plus) this.plus.setAttribute('aria-expanded', 'true');
      var first = this.panel.querySelector('.ange-qa__size:not([disabled])');
      if (first) first.focus({ preventScroll: true });
    }

    close() {
      if (!this.panel) return;
      this.panel.hidden = true;
      this.classList.remove('is-open');
      if (this.plus) this.plus.setAttribute('aria-expanded', 'false');
      if (this.error) this.error.textContent = '';
    }

    getCart() {
      return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    }

    add(variantId) {
      if (!variantId || this.classList.contains('is-loading')) return;
      this.classList.add('is-loading');
      if (this.error) this.error.textContent = '';

      const cart = this.getCart();
      const body = { items: [{ id: Number(variantId), quantity: 1 }] };
      if (cart && typeof cart.getSectionsToRender === 'function') {
        body.sections = cart.getSectionsToRender().map((section) => section.id);
        body.sections_url = window.location.pathname;
      }
      // Same as the theme's own Add to cart button: tell the cart drawer which element
      // to return focus to when it closes (the "+"), so focus never gets stuck inside
      // the closed drawer.
      if (cart && typeof cart.setActiveElement === 'function' && this.plus) {
        cart.setActiveElement(this.plus);
      }

      const addUrl = (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';

      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((state) => {
          if (state.status) {
            const message = state.description || state.message || 'This size could not be added.';
            if (this.error) {
              if (this.panel && this.panel.hidden) this.open();
              this.error.textContent = message;
            }
            return;
          }

          this.close();
          if (document.activeElement && this.contains(document.activeElement)) document.activeElement.blur();

          if (cart && typeof cart.renderContents === 'function' && state.sections) {
            state.id = Number(variantId);
            cart.renderContents(state);
            if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          } else {
            window.location.href = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
          }

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ange-quick-add', productVariantId: Number(variantId), cartData: state });
          }
        })
        .catch(() => {
          if (this.error) {
            if (this.panel && this.panel.hidden) this.open();
            this.error.textContent = 'Something went wrong. Please try again.';
          }
        })
        .finally(() => {
          this.classList.remove('is-loading');
        });
    }
  }

  customElements.define('ange-quick-add', AngeQuickAdd);
})();
